module.exports = __webpack_public_path__ + "assets/88ecba7db5381c62f45c5eef63f5b1c3.mp3";